<template>
  <div>
    <v-btn color="success" @click="onClickCsvCheck"
      >Enter to start checking the CSV</v-btn
    >
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple-accent-4"
    ></v-progress-linear>
    <div class="text-2xl text-left my-4">
      EMAIL DUPLICATE RESULTS:
    </div>
    <div v-for="(item, i) in items" :key="i">
      {{ item }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return { loading: false, items: [] };
  },
  methods: {
    onClickCsvCheck() {
      this.loading = true;
      axios.post("/csv-checker/").then((res) => {
        this.loading = false;
        this.items = res.data.output;
      });
    },
  },
};
</script>
